'use client';
// 首頁 - 手機版廣告彈窗

import { useState, useEffect } from 'react';
import bannerClient from '@/common/apiClient/bannerClient';
import { PROMO_BANNER_POSITION_CODE } from '@/common/constant';
import Image from 'next/image';

const IndexPopAd = () => {
    // Cookie key name
    const COOKIE_KEY = 'index_pop_ad_closed';

    // 顯示彈窗
    const [showPop, setShowPop] = useState(false);
    const [banner, setBanner] = useState(null);

    // 檢查 Cookie 是否已存在
    const hasClosedToday = () => {
        const cookie = document.cookie.split('; ').find((row) => row.startsWith(`${COOKIE_KEY}=`));
        return !!cookie;
    };

    // 設定 cookie 到今天 23:59:59
    const setTodayExpireCookie = () => {
        const expire = new Date();
        expire.setHours(23, 59, 59, 999);
        document.cookie = `${COOKIE_KEY}=1;expires=${expire.toUTCString()};path=/;SameSite=Lax`;
    };

    // cookie 裡沒有資料才 取得廣告
    const getBanner = async () => {
        try {
            const { banners } = await bannerClient.getBanner(
                'tw',
                PROMO_BANNER_POSITION_CODE.H18_BOTTOM_RIGHT_POPUP_MB
            );
            if (banners && banners?.length) {
                setBanner(banners?.[0]);
                setShowPop(true);
            }
        } catch (e) {
            console.error(e);
        }
    };

    // 關閉彈窗
    const onClose = () => {
        setShowPop(false);
        setTodayExpireCookie();
    };

    useEffect(() => {
        if (!hasClosedToday()) {
            getBanner();
        }
    }, []);

    if (showPop && banner)
        return (
            <div className="hidden umd:block max-w-[214px] fixed bottom-[65px] right-[10px] z-[20]">
                <div className="relative">
                    <button
                        onClick={onClose}
                        className="w-[30px] aspect-[1] p-[4px] absolute top-[-25px] left-[-25px] z-[1]"
                    >
                        <Image
                            className="w-full h-full"
                            width={26}
                            height={26}
                            src="/images/icon/icon_grey_close.svg"
                            alt="icon"
                        />
                    </button>
                    <a
                        href={banner?.link}
                        target="_blank"
                        rel="noreferrer noopener"
                        className="block w-full relative z-[0]"
                    >
                        <img
                            className="w-full h-full !object-contain object-center max-h-[176px]"
                            src={banner?.img}
                            alt="banner"
                        />
                    </a>
                </div>
            </div>
        );

    return <></>;
};

export default IndexPopAd;
